import React from 'react';
import { nanoid } from 'nanoid/non-secure';
const getName = Component => Component && Component.constructor && Component.constructor.name || 'dsId';
function generateId(Component) {
  const componentName = getName(Component);
  const randomId = nanoid(10);
  return `${componentName}_${randomId}`;
}
function useId(id) {
  const idRef = React.useRef(id || generateId());
  return idRef.current;
}
export default generateId;
export { useId };